<template>
  <section v-if="hasNews" class="home__section home-news">
    <div class="container">
      <div class="home__title">
        <HomeTitle
          :english="'News'"
          :title="$t('home.title.news')"
        />
      </div>

      <div class="home__content">
        <el-tabs v-model="homeNewsActive">
          <el-tab-pane
            v-for="item in homeNews"
            :key="item.newsCategoryName"
            :label="item.newsCategoryName"
            :name="item.newsCategoryName"
          >
            <div class="home-news__list">
              <router-link
                v-for="newsItem in item.newsList"
                :key="newsItem.newsId"
                :to="{
                  name: 'newsDetail',
                  params: { id: newsItem.newsId, fromIndex: true }
                }"
                class="home-news__item"
              >
                <div class="home-news__date">
                  <p>{{ newsItem.newsStartDate | toTaipei | moment('YYYY.MM.DD') }}</p>
                </div>

                <div class="home-news__tag">
                  <span>{{ newsItem.newsCategoryName }}</span>
                </div>

                <div class="home-news__content">
                  <p>{{ newsItem.newsSubject }}</p>
                </div>
              </router-link>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="home__more">
        <router-link to="/news">
          <span>{{ $t('home.button.moreNews') }}</span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { GetHomeNews } from '@/api/NewsApi';

import HomeTitle from '@/components/HomeTitle.vue';

export default {
  components: {
    HomeTitle,
  },
  data() {
    return {
      homeNews: [],
      homeNewsActive: '',
    };
  },
  async mounted() {
    await this.GetList();
  },
  methods: {
    GetList() {
      return new Promise((resolve) => {
        GetHomeNews({
          categoryCount: 4,
          newsCount: 5,
        })
          .then((response) => {
            if (response.data.statusCode === 0) {
              this.homeNews = response.data.data;
              this.homeNewsActive = this.homeNews[0].newsCategoryName;
            }

            resolve();
          });
      });
    },
  },
  computed: {
    hasNews() {
      try {
        if (this.homeNews.length > 0) {
          if (this.homeNews[0].newsList.length > 0) {
            return true;
          }
        }

        return false;
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
